import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

import { GetAppsParams } from "api";
import { Credentials } from "auth";
import { ClientApp } from "models";

import { AdminEndAction, ErrorPayload } from "./ErrorAction";

export type AdminFetchAppList = "ADMIN_FETCH_APP_LIST";
export const ADMIN_FETCH_APP_LIST: AdminFetchAppList = "ADMIN_FETCH_APP_LIST";

export type AdminFetchAppListEnd = "ADMIN_FETCH_APP_LIST_END";
export const ADMIN_FETCH_APP_LIST_END: AdminFetchAppListEnd = "ADMIN_FETCH_APP_LIST_END";

export interface AdminFetchAppListAction extends Action {
    type: AdminFetchAppList;
    payload: {
        credentials: Credentials;
        params?: GetAppsParams;
    };
}

export function adminFetchAppList(params?: GetAppsParams): ThunkAction<any, State, any, AdminFetchAppListAction> {
    return (dispatch: Dispatch<AdminFetchAppListAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(adminFetchAppListWithCredentials(credentials, params));
    };
}

function adminFetchAppListWithCredentials(
    credentials: Credentials,
    params?: GetAppsParams
): AdminFetchAppListAction {
    return {
        payload: {
            credentials,
            params
        },
        type: ADMIN_FETCH_APP_LIST
    };
}

export interface AdminFetchAppListPayload extends ErrorPayload {
    apps: ClientApp[];
}

export interface AdminFetchAppListEndAction extends AdminEndAction<AdminFetchAppListPayload> {
    type: AdminFetchAppListEnd;
}

export function adminFetchAppListEnd(error?: Error, apps?: ClientApp[]): AdminFetchAppListEndAction {
    return {
        payload: {
            apps,
            error
        },
        type: ADMIN_FETCH_APP_LIST_END
    };
}
